<c-card *transloco="let t">
    <c-card-body class="px-2">

            <c-row>
              <c-col class="col-lg-6 col-12">
                  <h1>{{ t('Escalation Procedure') }}</h1>
              </c-col>
              <c-col class="col-lg-6 col-12 text-end">
                <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/articles/35352948598673-Understanding-Setting-up-an-Escalation-Procedure" target="_new" role="button"><i class="fa-regular fa-circle-question"></i> {{ t('Escalation Procedure Help') }}</a>
              </c-col>
            </c-row>

            <c-row>
              <c-col class="col-12">

                <div class="card mb-2">
                  <div class="card-body">
                    <p><b class="text-danger">{{ t('THIS IS NOT AN AUTOMATED PROCESS') }}</b></p>
                    <p>{{ t('The Escalation Procedure contains manual steps, for Monitors to assist Workers, should a Check In be missed or a Help Alert is issued.') }}</p>
                    <p>{{ t('For ') }}<b>{{ t('automated alerts') }}</b> {{ t('please use ') }}<a href="https://okalone.zendesk.com/hc/en-gb/articles/35353033606289-Setting-Up-Worker-Reminders" target="_new">{{ t('Worker Reminders') }}</a> {{ t('or') }} <a href="https://okalone.zendesk.com/hc/en-gb/articles/35352962127377-Alert-Loops-Sequenced-Monitor-Alerts" target="_new">{{ t('Alert Loops') }}</a>, {{ t('which are part of our')}} <a href="https://www.okaloneworker.com/what-is-the-comms-plan/" target="_new">{{ t('Comms Plan') }}</a>.</p>

                    <p><b>{{ t('The procedure you are seeing is the Company Escalation Procedure. It will apply to all workers UNLESS they are part of a Group Escalation Procedure or have a unique escalation procedure in their worker profile. The group escalation OVER-RIDES the company escalation, and a worker escalation OVER-RIDES any group or company escalation procedures.') }}</b><br/></p>

                    <b>{{ t('If you are using the Safety Monitoring Center then this Escalation Procedure will not be used. Please see the specific Escalation Plan for the Safety Monitoring Center.') }}</b>
                  </div>
                </div>

                <ng-container *ngIf="!editing && escalation && escalation.type ">


                  <button type="button" class="btn btn-outline-primary me-1" (click)="chooseEdit('wizard')">
                    <span *ngIf="escalation.type=='wizard'"><i class="fa-solid fa-pencil"></i>{{ t(' Edit the Escalation Procedure') }}</span>
                    <span *ngIf="escalation.type!='wizard'"><i class="fa-solid fa-plus"></i>{{ t(' Build an Escalation Procedure') }}</span>
                  </button>

                  <button type="button" class="btn btn-outline-primary me-1" (click)="chooseEdit('custom')">
                    <span *ngIf="escalation.type=='custom'"><i class="fa-solid fa-pencil"></i>{{ t(' Edit the Escalation Procedure') }}</span>
                    <span *ngIf="escalation.type!='custom'"><i class="fa-solid fa-plus"></i>{{ t(' Enter my own Escalation Procedure') }}</span>

                  </button>

                </ng-container>


                <app-escalation-edit-custom *ngIf="editing && edit_view=='custom'" [escalation]="escalation" (completed)="onCompleted($event)"></app-escalation-edit-custom>

                <app-escalation-edit-wizard *ngIf="editing && edit_view=='wizard'" [escalation]="escalation" (completed)="onCompleted($event)"></app-escalation-edit-wizard>


                <div class="card mt-2" *ngIf="escalation && !editing">
                  <div class="card-header">
                    {{ t('Your Company Escalation Procedure') }}
                  </div>
                  <div class="card-body" [innerHtml]="escalation.html">

                  </div>
                </div>

              </c-col>
            </c-row>

</c-card-body>
</c-card>
